module.exports = __webpack_public_path__ + "img/PL08213.d30f40e7.png";